import { queryOptions, useQuery } from '@tanstack/react-query'
import { getToken } from '../internal/tokenCallback'
import { meAdmin } from '../queries/admin.queries'

/** Admin connecté (`GET /admin/me`) ; `null` sans jeton ou en échec. */
export const getAdminMeOptions = () =>
  queryOptions({
    queryKey: ['admin-me'],
    queryFn: async () => {
      const token = await getToken()
      if (!token) {
        return null // Pas de token (null ou '') → pas de requête, donc pas de 401
      }
      try {
        const response = await meAdmin()
        return response.user
      } catch {
        return null
      }
    },
  })

export const useAdminMe = (options?: { enabled?: boolean }) =>
  useQuery({ ...getAdminMeOptions(), enabled: options?.enabled ?? true })
